/**
 * Extracts a human-readable message from a (possibly normalized) API error.
 *
 * SEPA calls go through the proxied client (`normalizeError`), which sets
 * `error.message` to the backend's `response.data.message` and stashes the full
 * response body on `error.details`. Raw axios errors expose it on
 * `response.data.message`. NestJS may return `message` as a string OR an array
 * (validation errors). We fall back to the caller's message only when nothing
 * meaningful is available (or the error is the generic axios "Request failed").
 */
export const getSepaErrorMessage = (error: unknown, fallback: string): string => {
  const e = error as {
    details?: { message?: unknown };
    response?: { data?: { message?: unknown } };
    message?: unknown;
  } | null;

  const raw = e?.details?.message ?? e?.response?.data?.message ?? e?.message;

  if (Array.isArray(raw)) {
    const joined = raw.filter(Boolean).join(", ");
    return joined.trim() ? joined : fallback;
  }

  if (typeof raw === "string" && raw.trim() && !/^request failed/i.test(raw)) {
    return raw;
  }

  return fallback;
};
